<div class="container-margin">
  <h2>
    {{
      isMaster
        ? translationService.getCompanyProductsText()
        : translationService.getYourProductsText()
    }}
  </h2>

  @if (!isMaster) {
    <div class="actions margin-top-10">
      <button
        type="button"
        mat-stroked-button
        color="primary"
        [matMenuTriggerFor]="productActionsMenu"
        [attr.aria-label]="translationService.getActionsText()"
      >
        {{ translationService.getActionsText() }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #productActionsMenu="matMenu">
        <button mat-menu-item (click)="goToCreate()">
          <mat-icon>add_circle</mat-icon>
          <span>{{ translationService.getCreateText() }}</span>
        </button>

        <button mat-menu-item (click)="goToImport()">
          <mat-icon>upload</mat-icon>
          <span>{{ translationService.getImportText() }}</span>
        </button>

        @if (canExportProducts) {
          <button
            type="button"
            mat-menu-item
            (click)="exportProducts()"
            [disabled]="exportingProducts"
            [attr.aria-busy]="exportingProducts"
          >
            <mat-icon>download</mat-icon>
            <span>{{ translationService.getExportProductsText() }}</span>
          </button>
        }

        <button mat-menu-item (click)="goToAddToCatalogue()">
          <mat-icon>playlist_add</mat-icon>
          <span>{{ translationService.getAddToCatalogueText() }}</span>
        </button>

        <button mat-menu-item (click)="goToBulkProductSharing()">
          <mat-icon>share</mat-icon>
          <span>{{ translationService.getBulkProductSharingText() }}</span>
        </button>
      </mat-menu>
    </div>
  }

  <div class="product-filter-section">
    <app-product-filter (filterOutput)="filter($event)"></app-product-filter>
  </div>

  <h2>
    {{ companyProductResults?.totalRecords ?? 0 }}
    {{ translationService.getResultsText() }}
  </h2>

  <app-product-list
    [products]="companyProductResults?.results ?? []"
    [displayedColumns]="displayedColumns"
    [showCloneButton]="!isMaster"
    [shouldShowCopiedIcons]="true"
    [shouldShowDiscontinued]="!isMaster"
    [shouldShowShareProducts]="!isMaster"
    (toggleDiscontinue)="onToggleDiscontinue($event)"
  ></app-product-list>

  <mat-paginator
    (page)="changePage($event)"
    [length]="companyProductResults?.totalRecords || 0"
    showFirstLastButtons
    pageSize="10"
  ></mat-paginator>
</div>
